var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructionsUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.99998H8V7.99998H4V8.99998ZM4 6.99998H8V5.99998H4V6.99998ZM3 11C2.725 11 2.48958 10.9021 2.29375 10.7062C2.09792 10.5104 2 10.275 2 9.99998V1.99998C2 1.72498 2.09792 1.48956 2.29375 1.29373C2.48958 1.09789 2.725 0.999977 3 0.999977H7L10 3.99998V9.99998C10 10.275 9.90208 10.5104 9.70625 10.7062C9.51042 10.9021 9.275 11 9 11H3ZM6.5 4.49998V1.99998H3V9.99998H9V4.49998H6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsUse);
export default __webpack_public_path__ + "static/media/instructions_use.1d8fbb370bac4ceddfab61a8b46679f3.svg";
export { ForwardRef as ReactComponent };